import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtStateService } from '../auth/jwt-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  private jwtStateService = inject(JwtStateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // No afegir token per a endpoints públics
    if (req.url.includes('/login') || req.url.includes('/actuator/health/appVersion')) {
      return next.handle(req);
    }

    // Només interceptar peticions GET i POST
    if (req.method !== 'GET' && req.method !== 'POST') {
      return next.handle(req);
    }

    // Obtenim el JWT des de l'AuthService
    const token = this.jwtStateService.jwt();

    if (token) {
      // Clonem la petició amb l'header d'autorització
      const headers = req.headers.set('Authorization', `Bearer ${token}`);
      const clonedReq = req.clone({ headers });
      return next.handle(clonedReq);
    }
    // Si no hi ha token, deixem passar la petició tal qual (o llençar error segons el flux)
    return next.handle(req);
  }
}
